import { StatusTypes, UserTypes } from 'types/GlobalTypes';
import { TypeColorsDictionary } from './Constants';

/**
 * @param type: type
 * @returns 'color
 */

export const getColor = (type: UserTypes | StatusTypes | null) => TypeColorsDictionary[type?.toLowerCase() || 'Other'];

// =================

export const convertObjectsToCsvString = (data: object[], excludedKeys: string[]): string => {
  const keys = Object.keys(data[0]).filter(k => excludedKeys.indexOf(k) === -1);
  const arrData = data.map(obj => keys.map(key => obj[key]));
  arrData.unshift(keys);

  const csv = arrData.map(row => row.join(',')).join('\n');
  return csv;
}

export const downloadCsvFile = (data: object[], excludedKeys: string[], filename: string) => {
  if (data.length === 0) {
    return;
  }
  const csvString = convertObjectsToCsvString(data, excludedKeys);

  downloadTextFile(csvString, 'text/csv;charset=utf-8;', filename);
}

export const downloadTextFile = (data: string, fileType: string, filename: string) => {
  const dataBlob = new Blob([data], { type: fileType });

  if (!downloadFile(dataBlob, filename)) {
    let csvWindow = window.open("");
    csvWindow?.document.write(data);
  };
}

export const downloadFile = (blob: Blob, filename: string): boolean => {
  const link = document.createElement("a");
  if (link.download !== undefined) { // feature detection
    // Browsers that support HTML5 download attribute
    let url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  }

  return false;
}
